import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { StatusBadge } from "../components/Kpi";

export default function Bookings() {
  const [items, setItems] = useState([]);
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api.get("/bookings").then(r => setItems(r.data));
    api.get("/projects").then(r => setProjects(r.data));
  }, []);
  return (
    <div className="space-y-6 animate-in">
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Closing</div>
        <h1 className="font-serif-display text-3xl">Bookings</h1>
        <p className="text-xs text-muted-foreground mt-1">Booking records are tracked without any deal value or agreement amounts, per policy.</p>
      </div>
      <Card className="overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/50 text-[11px] uppercase tracking-wider text-muted-foreground">
            <tr>
              <th className="text-left px-4 py-3">Code</th>
              <th className="text-left px-4 py-3">Client</th>
              <th className="text-left px-4 py-3">Project</th>
              <th className="text-left px-4 py-3">Tower / Unit</th>
              <th className="text-left px-4 py-3">Config</th>
              <th className="text-left px-4 py-3">Carpet (sqft)</th>
              <th className="text-left px-4 py-3">Booking Date</th>
              <th className="text-left px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map(b => {
              const p = projects.find(x => x.id === b.project_id);
              return (
                <tr key={b.id} className="border-t border-border hover:bg-accent/5">
                  <td className="px-4 py-3 font-mono text-xs">{b.booking_code}</td>
                  <td className="px-4 py-3">{b.client_name}</td>
                  <td className="px-4 py-3">{p?.name || "-"}</td>
                  <td className="px-4 py-3 text-xs">{b.tower} · {b.unit_number}</td>
                  <td className="px-4 py-3">{b.configuration}</td>
                  <td className="px-4 py-3 font-mono text-xs">{b.carpet_area}</td>
                  <td className="px-4 py-3 text-xs">{b.booking_date}</td>
                  <td className="px-4 py-3"><StatusBadge status={b.booking_status}/></td>
                </tr>
              );
            })}
            {items.length === 0 && <tr><td colSpan="8" className="px-4 py-10 text-center text-muted-foreground">No bookings yet.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
